import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

const URL = environment.partner;

@Injectable()

export class ReversaLiquidacionService {

  constructor(
    public _http: HttpClient
  ) { }

  reversaLiquidacion(form : any): Observable<any> {
    let url = environment.reversaLiquidacion;
    let params = JSON.stringify(form);
    let headersResp = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.post(`${url}`, params, { headers: headersResp });
  }

  autorizaLiquidacion(form : any): Observable<any> {
    let url = environment.autorizaLiquidacion;
    let params = JSON.stringify(form);
    let headersResp = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.post(`${url}`, params, { headers: headersResp });
  }

  RelaPagoRepo(form : any): Observable<any> {
    let url = environment.relacionPagoRepo;
    let params = JSON.stringify(form);
    let headersResp = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.post(`${url}`, params, { headers: headersResp });
  }

}
